<script setup lang="ts">
import bankerPassword from '@/routes/banker/password'
import { Head, useForm } from '@inertiajs/vue3'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const props = defineProps<{
  email: string
  token: string
}>()

const form = useForm({
  email: props.email,
  token: props.token,
  password: null,
  password_confirmation: null,
})
</script>

<template>
  <Head :title="t('title')" />

  <AuthCard>
    <template #title>{{ t('title') }}</template>
    <template #subtitle>{{ t('subtitle') }}</template>

    <template #content>
      <div class="space-y-4">
        <InertiaFormField :label="t('form.password.label')" required :error="form.errors.password">
          <InputText v-model="form.password" name="password" type="password" />
        </InertiaFormField>
        <InertiaFormField
          :label="t('form.password_confirmation.label')"
          required
          :error="form.errors.password_confirmation">
          <InputText v-model="form.password_confirmation" name="password_confirmation" type="password" />
        </InertiaFormField>
      </div>
    </template>

    <template #footer>
      <div class="flex justify-end">
        <Button
          :label="t('form.submit.label')"
          :loading="form.processing"
          @click="form.post(bankerPassword.setup.store().url)" />
      </div>
    </template>
  </AuthCard>
</template>

<i18n>
{
  "en": {
    "title": "Set Password",
    "subtitle": "Choose your personal password to activate your bank admin access",
    "form": {
      "password": {
        "label": "Password"
      },
      "password_confirmation": {
        "label": "Confirm Password"
      },
      "submit": {
        "label": "Set Password"
      }
    }
  },
  "de": {
    "title": "Passwort festlegen",
    "subtitle": "Wählen Sie Ihr persönliches Passwort, um Ihren Bank-Admin-Zugang zu aktivieren",
    "form": {
      "password": {
        "label": "Passwort"
      },
      "password_confirmation": {
        "label": "Passwort bestätigen"
      },
      "submit": {
        "label": "Passwort festlegen"
      }
    }
  }
}
</i18n>
